import pusherManager from '@chegg-wt/core-wa/utils/pusherManager'
import {
  CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_ANALYZE_EVENT,
  CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_EXPAND_ANALYZE_EVENT,
  CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_SHORTEN_ANALYZE_EVENT,
} from '@chegg-wt/core-wa/constants/pusher'
import { paraphraseSelectionDataHandler } from '@chegg-wt/core-wa/utils/pusherDataHandlers'
import {
  SentenceOffset,
  SetError,
  SetIsLoading,
  WtPusherEvent,
} from '@chegg-wt/core-wa/state/types'
import { QuickActionPanelType } from '@chegg-wt/core-wa/types'
import { CheckTypeInput } from '@chegg-wt/core/globalTypesOneGraph'

type FetchSentenceFeedbackParams = {
  qaRightPanelSentences: SentenceOffset[]
  onSubscribe: (eventData: WtPusherEvent) => void
  setError: SetError
  setIsLoading: SetIsLoading
  quickActionType?: QuickActionPanelType
  paperId?: string
}

export const quickActionMap = {
  [QuickActionPanelType.PARAPHRASE]: {
    checkType: CheckTypeInput.PARAPHRASE_SELECTION,
    channel: CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_ANALYZE_EVENT,
  },
  [QuickActionPanelType.SHORTEN]: {
    checkType: CheckTypeInput.PARAPHRASE_SELECTION_SHORTEN,
    channel: CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_SHORTEN_ANALYZE_EVENT,
  },
  [QuickActionPanelType.EXPAND]: {
    checkType: CheckTypeInput.PARAPHRASE_SELECTION_EXPAND,
    channel: CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_EXPAND_ANALYZE_EVENT,
  },
}

export const fetchParaphraseFeedback = async ({
  qaRightPanelSentences,
  onSubscribe,
  setError,
  setIsLoading,
  paperId,
  quickActionType = QuickActionPanelType.PARAPHRASE,
}: FetchSentenceFeedbackParams) => {
  setIsLoading(true)
  setError(null)
  const quickAction = quickActionMap[quickActionType]

  try {
    await pusherManager.subscribe(quickAction.channel, onSubscribe)
  } catch {
    setIsLoading(false)
    setError({
      code: 'PUSHER_CONNECTION_ERROR',
      message: `${quickActionType} | Couldn't connect to pusher`,
    })
    return
  }
  const traceId = await pusherManager.getTraceId()

  const initiatedAt = new Date().toISOString()
  paraphraseSelectionDataHandler.enableParaphraseFeedbackAcceptance(
    qaRightPanelSentences,
    initiatedAt,
    traceId,
    paperId
  )

  paraphraseSelectionDataHandler.handleParaphraseCall(
    traceId,
    paperId,
    qaRightPanelSentences,
    initiatedAt,
    setError,
    setIsLoading,
    quickAction.checkType
  )
}
